import React, { useEffect, useState } from "react";
import Styles from "./courseUploader.module.css";
import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  Select,
  Stack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";
import endpoints from "../../middleware/endpoint";
import { get } from "../../middleware/api";
import { IoAdd } from "react-icons/io5";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { IoIosClose } from "react-icons/io";
import { post } from "../../middleware/api";
import { toast } from "react-toastify";
import { BOLoading } from "../elements/elements";
import CourseUploader from "./CourseUploader";
import { decrypt } from '../../middleware/auth'
const { v4: uuidv4 } = require("uuid");

export default function AddExperience(props) {
  let userId = ""
  const { selectedForm, setSelectedForm } = props;
  const [fetchedData, setFetchedData] = useState([]);
  const [newExpData, setNewExpData] = useState({
    uuid: uuidv4(),
    name: "",
    role: "",
    yoe: "",
    duration: "",
    startingDate: "",
    endingDate: "",
  });
  const [editableData, setEditableData] = useState({});

  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const getExperienceData = () => {
    try {      
      setLoading(true);
      post(endpoints.getExperienceData, {
        user_id:userId
      })
      .then((APIData) => {
        setFetchedData(APIData.data);
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch all the experiences
  useEffect(() => {
    const userDetail = JSON.parse(decrypt(localStorage.getItem('userData')));
    userId = userDetail.id
    setNewExpData({...newExpData, id:userDetail.id})
    getExperienceData();
  }, []);

  // Add New Experience
  const AddNewExp = () => {
    try {
      post(endpoints.createExperience, newExpData)
        .then((res) => {
          if (res.status === 401) {
            toast.error("Kindly fill all the fields properly.");
          } else {
            getExperienceData();
            toast.success("Experience Added Successfully");
            setNewExpData({
              uuid: uuidv4(),
              name: "",
              role: "",
              yoe: "",
              duration: "",
              startingDate: "",
              endingDate: "",
            });
            // let form = (document.getElementById("AddExpForm").style.display =
            //   "none");
          }
        })
        .catch((error) => {
          toast.error("Failed to Add");
        });
    } catch (error) {
      toast.error("Some Error Occured");
    }
  };

  // Delete a Experience
  const deleteExperience = (id) => {
    try {
      post(endpoints.deleteExperience, {
        id: id,
      })
        .then((res) => {
          getExperienceData();
          toast.success("Deleted Successfully");
        })
        .catch((error) => {
          toast.error("Failed to Delete");
        });
    } catch (error) {
      toast.error("Some Error Occured");
    }
  };

  // Edit the Experience
  const editExp = () => {
    try {
      post(endpoints.updateExperience, editableData)
        .then((res) => {
          getExperienceData();
          toast.success("Update Successfully");
          // let form = (document.getElementById("EditExpForm").style.display =
          //   "none");
        })
        .catch((error) => {
          toast.error("Failed to update");
        });
    } catch (error) {
      toast.error("Some Error Occured");
    }
  };

  // const OpenAddExpForm = () => {
  //   let form = (document.getElementById("AddExpForm").style.display = "block");
  // };

  const CloseAddExpForm = () => {
    let form = (document.getElementById("AddExpForm").style.display = "none");
  };

  const HandleEditButton = (editableData) => {
    onOpen();
    // let form = (document.getElementById("EditExpForm").style.display = "block");
    setEditableData(editableData);
  };

  const CloseEditExpForm = () => {
    let form = (document.getElementById("EditExpForm").style.display = "none");
  };

  const handleInput = (e) => {
    setNewExpData({ ...newExpData, [e.target.name]: e.target.value });
  };

  const handleChange = (e) => {
    setEditableData({ ...editableData, [e.target.name]: e.target.value });
  };

  return (
    // <>

    // {
    //     (fetchedData)?
    //     fetchedData.map((expData)=>{
    //         return(
    //             <>
    //                         <form id={expData.id}>
    //                         <Box className={Styles?.addProfileBody} overflowX="scroll">
    //                                         <Box p="3" className={Styles?.textAlignLeft}>
    //                                             <Heading
    //                                                 as={"h6"}
    //                                             >
    //                                                 Experience Details
    //                                             </Heading>
    //                                         </Box>
    //                                         <Flex>
    //                                             <Box flex="1" p="3" className={Styles?.textAlignLeft}>
    //                                                 <Text>
    //                                                     Organization Name
    //                                                 </Text>
    //                                                 <Input
    //                                                     name="orgName"
    //                                                     placeholder='Enter Organization Name'
    //                                                     value={expData.organization_name}
    //                                                     // onChange={(e) => {
    //                                                     // setFullName(e.target.value);
    //                                                     // handleChange(e);
    //                                                 // }}
    //                                                 // onBlur={handleBlur} placeholder="Enter your full name"
    //                                                 >
    //                                                 </Input>
    //                                                 {/* {!!errors['fullName'] && !!touched['fullName'] ? <Text className={Styles?.errorField}>{errors['fullName']}</Text> : ""} */}

    //                                             </Box>
    //                                             <Box flex="1" p="3" className={Styles?.textAlignLeft}>
    //                                                 <Text>
    //                                                     Role
    //                                                 </Text>
    //                                                 <Input name="role"
    //                                                 placeholder='Enter Your Role'
    //                                                 value={expData.experience_role}

    //                                                 // placeholder={(userDetails.roles)?userDetails.roles:"Select Option"}
    //                                                 >
    //                                                     {/* <option value='admin'>Admin</option>
    //                                                     <option value='student'>Student</option>
    //                                                     <option value='learner'>Learner</option>
    //                                                     <option value='university'>University</option>
    //                                                     <option value='mentor'>Mentor</option>
    //                                                     <option value='department'>Department</option> */}
    //                                                 </Input>
    //                                                 {/* {!!errors['userRole'] && !!touched['userRole'] ? <Text className={Styles?.errorField}>{errors['userRole']}</Text> : ""} */}
    //                                             </Box>
    //                                         </Flex>
    //                                         <Flex>
    //                                             <Box flex="1" p="3" className={Styles?.textAlignLeft}>
    //                                                 <Text>
    //                                                     Year of Experience
    //                                                 </Text>
    //                                                 <Input
    //                                                 placeholder='Enter Year of Experience'
    //                                                 value={expData.yoe}

    //                                                 // onBlur={handleBlur}
    //                                                 // onChange={handleChange}
    //                                                 // value={userDetails.mobile_number}
    //                                                 // name="yoe"
    //                                                 // placeholder="Enter Year of Experience"
    //                                                 >

    //                                                 </Input>
    //                                                 {/* {!!errors['phoneNumber'] && !!touched['phoneNumber'] ? <Text className={Styles?.errorField}>{errors['phoneNumber']}</Text> : ""} */}

    //                                             </Box>
    //                                             <Box flex="1" p="3" className={Styles?.textAlignLeft}>
    //                                                 <Text>Starting Date</Text>
    //                                                 <Input type="text"
    //                                                 value={expData.startingDate}
    //                                                 placeholder="MM/DD/YY"
    //                                                 // onBlur={handleBlur}
    //                                                 // onChange={handleChange}
    //                                                 // name="emailAddress"
    //                                                 // placeholder="Enter your email address"
    //                                                 // value={userDetails.email_id}
    //                                                 >

    //                                                 </Input>
    //                                                 {/* {!!errors['emailAddress'] && !!touched['emailAddress'] ? <Text className={Styles?.errorField}>{errors['emailAddress']}</Text> : ""} */}
    //                                             </Box>
    //                                         </Flex>
    //                                         <Flex>
    //                                             <Box flex="1" p="3" className={Styles?.textAlignLeft} w={"50%"}>
    //                                                 <Text>
    //                                                     Ending Date
    //                                                 </Text>
    //                                                 <Input
    //                                                 type="text"
    //                                                 value={expData.endingDate}
    //                                                 // onBlur={handleBlur}
    //                                                 // onChange={handleChange}
    //                                                 // value={userDetails.mobile_number}
    //                                                 // name="yoe"
    //                                                 // placeholder="Enter Year of Experience"
    //                                                 >

    //                                                 </Input>
    //                                                 {/* {!!errors['phoneNumber'] && !!touched['phoneNumber'] ? <Text className={Styles?.errorField}>{errors['phoneNumber']}</Text> : ""} */}
    //                                             </Box>
    //                                             {/* <Box flex="1" p="3" className={Styles?.textAlignLeft} w={"50%"}>
    //                                                 <Text>
    //                                                     New Experience
    //                                                 </Text>
    //                                                 <Button onClick={AddNewPage}>Add New Experience</Button>
    //                                             </Box> */}
    //                                         </Flex>
    //                                         <Box className={Styles?.addProfileFooter} mt={5} >
    //                                         {/* <Button
    //                                         type="submit"
    //                                         // onClick={UploadCertificates}
    //                                         >Save</Button> */}
    //                                         </Box>
    //                         </Box>
    //                         </form>
    //             </>
    //         )
    //     })
    //     :
    //     ""
    // }

    // <center><Button w="93%" padding="10px" bg="#6c31ee" color="white" onClick={AddNewPage}>Add New Experience</Button></center>
    // {
    //     (fetchedData.length>0)?
    //     <center><Button w="93%" padding="7px" bg="#6c31ee" color="white" mt="8px">Save</Button></center>
    //     : ""
    // }
    // </>

    <>
      {/* ************************Add Experience Form***************************************************** */}

      <form style={{ display: "none" }}>
        <Box overflowX="scroll">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text
              fontSize="24px"
              color="Black"
              fontWeight="700px"
              textAlign="left"
              border="none"
              padding="5px"
            >
              Add New Experience
            </Text>
            <IoIosClose
              color="black"
              size="30px"
              cursor="pointer"
              onClick={CloseAddExpForm}
            />
          </Box>
          <Flex>
            <Box flex="1" p="3" className={Styles?.textAlignLeft}>
              <Text>Organization Name</Text>
              <Input
                name="name"
                placeholder="Enter Organization Name"
                onChange={handleInput}
              ></Input>
            </Box>
            <Box flex="1" p="3" className={Styles?.textAlignLeft}>
              <Text>Role</Text>
              <Input
                name="role"
                placeholder="Enter Your Role"
                onChange={handleInput}
              ></Input>
            </Box>
          </Flex>
          <Flex>
            <Box flex="1" p="3" className={Styles?.textAlignLeft}>
              <Text>Year of Experience</Text>
              <Input
                name="yoe"
                placeholder="Enter Year of Experience"
                onChange={handleInput}
              ></Input>
            </Box>
            <Box flex="1" p="3" className={Styles?.textAlignLeft}>
              <Text>Start Date</Text>
              <Input
                type="text"
                // value={expData.startingDate}
                name="startingDate"
                placeholder="MM/DD/YY"
                onChange={handleInput}
              ></Input>
            </Box>
          </Flex>
          <Flex>
            <Box flex="2" p="3" className={Styles?.textAlignLeft} w={"50%"}>
              <Text>End Date</Text>
              <Input
                type="text"
                placeholder="MM/DD/YY"
                name="endingDate"
                onChange={handleInput}
              ></Input>
              <Button
                float="right"
                marginRight="5px"
                mt="10px"
                onClick={AddNewExp}
              >
                Save
              </Button>
            </Box>
          </Flex>
          <Box className={Styles?.addProfileFooter} mt={5}></Box>
        </Box>
      </form>

      {/* ************************Edit Experience Form***************************************************** */}
      <form style={{ display: "none" }}>
        <Box className={Styles?.addProfileBody} overflowX="scroll">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text
              fontSize="24px"
              color="Black"
              fontWeight="700px"
              textAlign="left"
              border="none"
              padding="5px"
            >
              {editableData === "" ? "Add New Experience" : "Edit Experience"}
            </Text>
            <IoIosClose
              color="black"
              size="30px"
              cursor="pointer"
              onClick={CloseEditExpForm}
            />
          </Box>
          <Flex>
            <Box flex="1" p="3" className={Styles?.textAlignLeft}>
              <Text>Organization Name</Text>
              <Input
                name="organization_name"
                placeholder="Enter Organization Name"
                value={editableData.organization_name}
                onChange={handleChange}
              ></Input>
              {/* {!!errors['fullName'] && !!touched['fullName'] ? <Text className={Styles?.errorField}>{errors['fullName']}</Text> : ""} */}
            </Box>
            <Box flex="1" p="3" className={Styles?.textAlignLeft}>
              <Text>Role</Text>
              <Input
                name="experience_role"
                placeholder="Enter Your Role"
                value={editableData.experience_role}
                onChange={handleChange}
              ></Input>
            </Box>
          </Flex>
          <Flex>
            <Box flex="1" p="3" className={Styles?.textAlignLeft}>
              <Text>Year of Experience</Text>
              <Input
                name="yoe"
                placeholder="Enter Year of Experience"
                value={editableData.yoe}
                onChange={handleChange}
              ></Input>
            </Box>
            <Box flex="1" p="3" className={Styles?.textAlignLeft}>
              <Text>Starting Date</Text>
              <Input
                type="text"
                name="startingDate"
                value={editableData.startingDate}
                placeholder="MM/DD/YY"
                onChange={handleChange}
              ></Input>
            </Box>
          </Flex>
          <Flex>
            <Box flex="2" p="3" className={Styles?.textAlignLeft} w={"50%"}>
              <Text>Ending Date</Text>
              <Input
                type="text"
                placeholder="MM/DD/YY"
                name="endingDate"
                value={editableData.endingDate}
                onChange={handleChange}
              ></Input>
              <Button
                float="right"
                marginRight="5px"
                mt="10px"
                onClick={editExp}
              >
                Save
              </Button>
            </Box>
          </Flex>
          <Box className={Styles?.addProfileFooter} mt={5}>
            {/* <Button 
                        type="submit"
                        // onClick={UploadCertificates}
                        >Save</Button> */}
          </Box>
        </Box>
      </form>
      <Box
        className={Styles?.addProfileFooter}
        mt={5}
        textAlign={"left"}
        onClick={() => setSelectedForm(1)}
      >
        <Button type="submit" alignSelf="self-start">
          Back
        </Button>
      </Box>
      <Box className={Styles?.addProfileExpBody} h="515px" overflowX="scroll">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Text fontSize="24px" color="Black" fontWeight="700" padding="5px">
            Experience
          </Text>
          <IoAdd
            color="black"
            size="30px"
            cursor="pointer"
            onClick={() => {
              // OpenAddExpForm();
              setAddForm(true);
              onOpen();
            }}
          />
        </Box>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            {!addForm ? (
              <>
                <ModalHeader>Edit Experience</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Box id="EditExpForm" mt="0px">
                    <Box
                      width="100%"
                      display="flex"
                      flexDir="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Input
                        type="text"
                        placeholder="Enter Role"
                        width="95%"
                        mt="15px"
                        height="40px"
                        name="experience_role"
                        value={editableData.experience_role}
                        onChange={handleChange}
                      ></Input>
                      <Input
                        type="text"
                        placeholder="Enter Organization Name"
                        mt="15px "
                        width="95%"
                        height="40px"
                        name="organization_name"
                        value={editableData.organization_name}
                        onChange={handleChange}
                      ></Input>
                      <Input
                        type="text"
                        placeholder="Enter Year of Experience"
                        mt="15px"
                        width="95%"
                        height="40px"
                        name="yoe"
                        value={editableData.yoe}
                        onChange={handleChange}
                      ></Input>
                      <Box
                        width="100%"
                        display="flex"
                        justifyContent="space-evenly"
                        alignItems="center"
                      >
                        <Input
                          type="text"
                          placeholder="Start Date (MM/DD/YY)"
                          mt="15px"
                          width="46%"
                          height="40px"
                          name="startingDate"
                          value={editableData.startingDate}
                          onChange={handleChange}
                        ></Input>
                        <Input
                          type="text"
                          placeholder="End Date (MM/DD/YY)"
                          mt="15px"
                          width="46%"
                          height="40px"
                          name="endingDate"
                          value={editableData.endingDate}
                          onChange={handleChange}
                        ></Input>
                      </Box>
                      <Box
                        width="100%"
                        display="flex"
                        justifyContent="space-evenly"
                        alignItems="center"
                      >
                        <Button
                          width="46%"
                          mt="15px"
                          height="40px"
                          color="white"
                          bgColor="#6e31ec"
                          onClick={() => {
                            editExp();
                            onClose();
                          }}
                        >
                          Save
                        </Button>
                        <Button
                          width="46%"
                          mt="15px"
                          height="40px"
                          onClick={() => {
                            onClose();
                            CloseEditExpForm();
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </ModalBody>
              </>
            ) : (
              <>
                <ModalHeader>Add Experience</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Box id="AddExpForm" mt="0px">
                    <Box
                      width="100%"
                      display="flex"
                      flexDir="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Input
                        type="text"
                        placeholder="Enter Role"
                        width="95%"
                        mt="15px"
                        height="40px"
                        name="role"
                        value={newExpData.role}
                        onChange={handleInput}
                      ></Input>
                      <Input
                        type="text"
                        placeholder="Enter Organization Name"
                        mt="15px "
                        width="95%"
                        height="40px"
                        name="name"
                        value={newExpData.name}
                        onChange={handleInput}
                      ></Input>
                      {/* <Input type='text' placeholder='Enter Year of Experience' mt="15px" width="95%" height="40px" name="yoe" value={newExpData.yoe} onChange={handleInput}></Input>  */}
                      <Box
                        width="100%"
                        display="flex"
                        justifyContent="space-evenly"
                        alignItems="center"
                      >
                        <Input
                          type="text"
                          mt="15px"
                          placeholder="Enter Year of Experience"
                          width="46%"
                          height="40px"
                          name="yoe"
                          value={newExpData.yoe}
                          onChange={handleInput}
                        ></Input>
                        <Select
                          mt="15px"
                          placeholder="Select Role"
                          width="46%"
                          height="40px"
                          name="duration"
                          value={newExpData.duration}
                          onChange={handleInput}
                        >
                          <option value="Years">Years</option>
                          <option value="Months">Months</option>
                        </Select>
                      </Box>
                      <Box
                        width="100%"
                        display="flex"
                        justifyContent="space-evenly"
                        alignItems="center"
                      >
                        <Input
                          type="date"
                          mt="15px"
                          placeholder="Start Date"
                          width="46%"
                          height="40px"
                          name="startingDate"
                          value={newExpData.startingDate}
                          onChange={handleInput}
                        ></Input>
                        <Input
                          type="date"
                          mt="15px"
                          placeholder="End Date"
                          width="46%"
                          height="40px"
                          name="endingDate"
                          value={newExpData.endingDate}
                          onChange={handleInput}
                        ></Input>
                      </Box>
                      <Box
                        width="100%"
                        display="flex"
                        justifyContent="space-evenly"
                        alignItems="center"
                      >
                        <Button
                          width="46%"
                          mt="15px"
                          height="40px"
                          color="white"
                          bgColor="#6e31ec"
                          onClick={() => {
                            AddNewExp();
                            onClose();
                          }}
                        >
                          Save
                        </Button>
                        <Button
                          width="46%"
                          mt="15px"
                          height="40px"
                          onClick={onClose}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </ModalBody>
              </>
            )}

            <ModalFooter>
              {/* <Button colorScheme="blue" mr={3} onClick={onClose}>
                Close
              </Button>
              <Button variant="ghost">Secondary Action</Button> */}
            </ModalFooter>
          </ModalContent>
        </Modal>

        {loading ? (
          <>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BOLoading />
            </div>
          </>
        ) : fetchedData ? (
          fetchedData.map((expData, index) => {
            return (
              <>
                <Box
                  display="flex"
                  h="auto"
                  justifyContent="space-between"
                  style={{ marginTop: "20px" }}
                >
                  <Box width="93%" paddingLeft="15px">
                    <Text fontSize="18px" color="Black" fontWeight="600">
                      {expData.experience_role}
                    </Text>
                    <Text fontSize="16px" color="Black" fontWeight="400">
                      {expData.organization_name}
                    </Text>
                    <Text
                      fontSize="16px"
                      color="gray"
                      fontWeight="200"
                    >{`${expData.startingDate} - ${expData.endingDate}`}</Text>
                    <Text
                      fontSize="16px"
                      color="gray"
                      fontWeight="200"
                    >{`${expData.yoe} ${expData.duration} Experience`}</Text>
                  </Box>
                  <Box height="40px" d="flex" flexDir="column" p="5px">
                    <MdModeEdit
                      color="darkgray"
                      size="20px"
                      cursor="pointer"
                      onClick={() => {
                        setAddForm(false);
                        HandleEditButton(fetchedData[index]);
                        onOpen();
                      }}
                    />
                    <MdDelete
                      color="darkgray"
                      size="20px"
                      cursor="pointer"
                      style={{ marginTop: "5px" }}
                      onClick={() => deleteExperience(expData.id)}
                    />
                  </Box>
                </Box>
              </>
            );
          })
        ) : 
          "No Experience Added"
        }
        {/* {
          (fetchedData=="")?
          <Text>No Experience Added</Text>
          :
          ""
        } */}
      </Box>

      <Box
        //   className={Styles?.addProfileFooter}
        mt={5}
        textAlign={"right"}
        onClick={() => setSelectedForm(3)}
      >
        <Button type="submit" bg="#6d31ed" color="white" colorScheme="purple">
          Next
        </Button>
      </Box>
    </>
  );
}
